import {
    typeAdapter, apiAdapter
}
from './passportAdapter';

var hostArr = location.hostname.split('.');
var hostName = hostArr[hostArr.length - 2];

var domain;
if (/focus\.cn/.test(location.host)) {
    domain = '//login.' + 'focus.cn/';
} else if (/focustest\.cn/.test(location.host)) {
    domain = '//login.focustest.cn/';
} else {
    var matched = location.host.match(/focus-(.*)\.cn/);
    if (matched && matched.length && matched[1]) {
        domain = '//login.focus-' + matched[1] + '.cn/';
    } else {
        domain = '//' + location.host + '/';
    }
}

var mock = false;

var proxy = function (resourceName, data, fn) {

    $.ajax({
        url: domain + (mock ? 'mock/' : '') + apiAdapter[resourceName] + '?timestamp=' +
            new Date().getTime(),
        data: data,
        dataType: 'json',
        type: mock ? 'get' : typeAdapter[resourceName],
        async: true,
        success: function (res) {
            fn(res);
        }
    });

};
module.exports = proxy;



// WEBPACK FOOTER //
// ./src/model/proxy/passportProxy.js